import { gql } from "graphql-request";

const CreateSupplierQuery = gql`
  mutation CreateSupplier($data: SupplierCreateDto!) {
  CreateSupplier(data: $data) {
    status
    error
    messege
  }
}
`;
export default CreateSupplierQuery;
